import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import Paso1 from "./PronetPaso1";
import Paso2 from "./PronetPaso2";
import Paso3 from "./PronetPaso3";
import PasoOtp from "./PasoOtp";
import Paso4 from "./PronetPaso4";
import Paso5 from "./PronetPaso5";
import ConfigService from "../../../services/configuracion/ConfigService";


export default class PronetPago extends Component {
  constructor(props) {
    super(props);
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.PasoOtp = React.createRef();
    this.paso4 = React.createRef();
    this.paso5 = React.createRef();
    this.state = {
      resultadoPaso1: undefined,
      resultadoPaso2: undefined,
      resultadoPaso3: undefined,
      datosCliente: undefined,
      detalleCuotas: undefined,
      buscar: undefined,
      ticket: undefined,
      datosPopUp: undefined,
      tipoTrx: undefined,
      esGrilla: undefined,
      formOriginal: undefined,
      codigoServicio: sessionStorage.getItem("servicio"),
      nombreServicio: sessionStorage.getItem("nombre"),
      imgServicio: sessionStorage.getItem("img"),
      entidadServicio: sessionStorage.getItem("entidad"),
      muestraPantallaEntrust:false,
      muestraPantallaOtpSms:false,
      pantallaSinCodigo:false
    };
    this.esCodigoBarra = "";
  }

  componentDidMount() {
    this.isPaso1.click();
  }

  respuestaPaso1 = (dataFromChild, buscar, tipoTrx, original) => {
    this.pagoCodigoBarra(dataFromChild);
    this.setState({ resultadoPaso1: dataFromChild, buscar: buscar, tipoTrx: tipoTrx, formOriginal: original});
  };

  respuestaPaso2 = (dataFromChild, tipoTrx, esGrilla, servicio, datosCliente) => {
    this.setState({ resultadoPaso2: dataFromChild, tipoTrx: tipoTrx, esGrilla: esGrilla, codigoServicio: servicio, datosCliente: datosCliente});
  };

  respuestaPaso3 = (dataFromChild, montoPagado, rptAnterior,_muestraPantallaEntrust,_codigootp) => {
    var valorCuenta = dataFromChild.ahorro + " - " + dataFromChild.descripcion + " Saldo: " + formatoSeparadorMilesValue(dataFromChild.saldoTotal) + " " + dataFromChild.moneda;
    var nroCuenta = dataFromChild.ahorro
  
    if(dataFromChild.ahorro === undefined){
      
    valorCuenta = this.state.cuenta
    nroCuenta = this.state.nroCuenta

    }
    var resultado3 = []

      var jsonData = JSON.parse(JSON.stringify(rptAnterior));
      //console.log("RECIBIDO COMO PARA PAGO"+JSON.stringify(rptAnterior))
      for (var i = 0; i < jsonData.length; i++) {
        var datos = JSON.parse(JSON.stringify(jsonData[i]));
        datos.concepto = datos.name;
        datos.valor = datos.value.split(".").join("");
        resultado3.push(datos);
       
      }

//console.log("CUENTA A ENVIAR "+valorCuenta+" nro de cuenta "+nroCuenta)
    this.setState({ resultadoPaso3: resultado3, cuenta: valorCuenta, nroCuenta: nroCuenta, muestraPantallaEntrust:_muestraPantallaEntrust,codigootp:_codigootp });

  };


respuestaPaso4 = (ticket,_nroOperacion) => {
  var cuentaDebito = this.state.cuenta.split("Saldo");
  cuentaDebito = cuentaDebito[0].trim();
  this.setState({ ticket: ticket, nroOperacion:_nroOperacion, cuenta: cuentaDebito });


};


/**
 * @author m_bareiro
 * Registra si el servicio cuenta con lectura de codigo de barra para el pago
 * @param camposArray
 */
pagoCodigoBarra(camposArray){
  for (let campo of camposArray) {
    if(campo.name.toLowerCase().includes("barra")){
      this.esCodigoBarra="OK";
      break;
    }
  }
}


render() {
  return (
    <div className="content-wrapper">
      <Titulo texto="Pagos de Servicios Pronet" />
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">

                  <StepWizard transitions="none" >
                    <Paso1 ref={this.paso1} 
                      codigo={this.state.codigoServicio}
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      respuestaPaso1={this.respuestaPaso1.bind(this)} 
                      formulario={this.state.formOriginal}
                    />
                    <Paso2 ref={this.paso2} 
                      codigo={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      resultadoPaso1={this.state.resultadoPaso1} 
                      buscar={this.state.buscar} 
                      respuestaPaso2={this.respuestaPaso2.bind(this)}
                    />
                    <Paso3 
                      ref={this.paso3} 
                      codigo={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      paso1={this.state.resultadoPaso1} 
                      buscar={this.state.buscar} 
                      respuestaPaso3={this.respuestaPaso3.bind(this)} 
                      paso2={this.state.resultadoPaso2} 
                      nroCuenta={this.state.nroCuenta}
                    />
                    <PasoOtp 
                      ref={this.PasoOtp}
                      codigo={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio}
                      // paso1={this.state.resultadoPaso1}
                      // paso2={this.state.resultadoPaso2}
                      // paso3={this.state.resultadoPaso3} 
                      codigootp = {this.state.codigootp}
                      muestraPantallaEntrust = {this.state.muestraPantallaEntrust}
                    />
                    <Paso4 
                      ref={this.paso4} 
                      codigo={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      paso3={this.state.resultadoPaso3} 
                      cuenta={this.state.cuenta} 
                      nroCuenta={this.state.nroCuenta} 
                      respuestaPaso4={this.respuestaPaso4.bind(this)} 
                      tipoTrx={this.state.tipoTrx} 
                      datosCliente={this.state.datosCliente}  
                      esCodigoBarra={this.esCodigoBarra}
                    />
                    <Paso5 
                      ref={this.paso5} 
                      codigo={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      paso4={this.state.ticket} 
                      cuenta={this.state.cuenta} 
                      nroOperacion={this.state.nroOperacion}
                    />
                  </StepWizard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button
        hidden
        ref={(a) => (this.isPaso1 = a)}
        className="btn btn-cu-primary"
        onClick={this.props.firstStep}
      ></button>
     
    </div>

  );

}
}